import { useContext } from 'react';
import PermissionContext from 'common/contexts/PermissionContext';

export default function usePermissionContext() {
  return useContext(PermissionContext);
}
